import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useTranslationContext } from "routes/schedule/plugins/translation/use-translation-context"
import { useReferenceState } from "lib/@hooks/use-reference"
import { OVERARCHING_INTRODUCTION } from "library/SFG20/constants.mjs"
import { NotEditMode } from "lib/@components/edit-mode"
import { NotInPdf } from "lib/@components/pdf/not-in-pdf"
import { Alert, Box, Button } from "@mui/material"
import { OverarchingIntroductionText } from "routes/schedule/plugins/overarching-introduction/overarching-introduction-text"
import Iconify from "minimals-template/components/Iconify"
import { InPdf } from "lib/@components/pdf/in-pdf"

export function OverarchingIntroduction() {
    const { code } = useBoundContext()
    const { labels: translationLabels } = useTranslationContext()
    const [showInfo, setShowInfo] = useReferenceState("showOverarchingIntroductionInfo", true)

    const isOverarchingSchedule = +code === +OVERARCHING_INTRODUCTION

    return (
        !isOverarchingSchedule && (
            <NotEditMode>
                <NotInPdf>
                    {showInfo ? (
                        <Alert
                            severity="info"
                            onClose={handleClose}
                            data-cy="overarching-introduction-info"
                            sx={{ mt: 2 }}
                        >
                            <OverarchingIntroductionText
                                overarchingIntroductionId={OVERARCHING_INTRODUCTION}
                                variant="body2"
                            />
                        </Alert>
                    ) : (
                        <Button
                            data-cy="overarching-introduction-reopen"
                            variant="outlined"
                            endIcon={<Iconify icon="ic:round-chevron-right" />}
                            onClick={handleShowInfo}
                            sx={{ mt: 2 }}
                        >
                            {translationLabels?.overarchingButton ?? "Overarching Introduction Information"}
                        </Button>
                    )}
                </NotInPdf>
                <InPdf>
                    <Box sx={{ mt: 2 }}>
                        <OverarchingIntroductionText overarchingIntroductionId={OVERARCHING_INTRODUCTION} />
                    </Box>
                </InPdf>
            </NotEditMode>
        )
    )

    function handleClose() {
        setShowInfo(false)
    }

    function handleShowInfo() {
        setShowInfo(true)
    }
}
